module.exports = __webpack_public_path__ + "static/banner_2-935493b21113456d30f2bbbc6ff7afd7.png";